import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { baseUrl } from "../shared/baseUrl";
import { SURAH_NAMES } from "../shared/surahNames";

function Taraweeh({
  queue,
  setQueue,
  setCurrent,
  setPlaying,
  liked,
  setLiked,
}) {
  const [taraweehData, settaraweehData] = useState(null);
  const [taraweehAudioList, setTaraweehAudioList] = useState([]);
  const { taraweehSlug } = useParams();

  useEffect(() => {
    fetch(baseUrl + `api/v1/taraweeh/${taraweehSlug}`)
      .then((res) => res.json())
      .then((data) => {
        settaraweehData(data);
        setTaraweehAudioList(Array.isArray(data.audio) ? data.audio : []);
      })
      .catch(() => {
        settaraweehData(null);
        setTaraweehAudioList([]);
      });
  }, [taraweehSlug]);

  const normalizeAudio = (taraweeh, taraweehData) => ({
    id: taraweeh.id,
    title: `${SURAH_NAMES[taraweeh.name]}`,
    reciter: "Year: " + taraweehData.year,
    riwaya: taraweehData.title + " " + taraweehData.city,
    cover: `${baseUrl}storage/${taraweehData.image}`,
    src: `${taraweeh.path}`,
  });

  const playAudio = (taraweeh) => {
    const normalized = normalizeAudio(taraweeh, taraweehData);

    // Copy queue and find index
    let newQueue = [...queue];
    let index = newQueue.findIndex((s) => s.id === normalized.id);

    if (index === -1) {
      newQueue.push(normalized);
      index = newQueue.length - 1;
    }

    setQueue(newQueue);
    setCurrent(index);
    setPlaying(true);
  };

  const toggleLike = (taraweeh) => {
    const normalized = normalizeAudio(taraweeh, taraweehData);

    let newLiked;
    if (liked.includes(normalized.id)) {
      newLiked = liked.filter((id) => id !== normalized.id);
    } else {
      newLiked = [...liked, normalized.id];

      // Add to queue if not present
      if (!queue.find((q) => q.id === normalized.id)) {
        setQueue([...queue, normalized]);
      }
    }

    setLiked(newLiked);
    localStorage.setItem("likedAudioList", JSON.stringify(newLiked));
  };

  const playtaraweeh = () => {
    const normalizedAudioList = taraweehAudioList.map((s) =>
      normalizeAudio(s, taraweehData),
    );

    // Merge new audio list into queue without duplicates
    const newQueue = [...queue];
    normalizedAudioList.forEach((s) => {
      if (!newQueue.find((q) => q.id === s.id)) newQueue.push(s);
    });

    setQueue(newQueue);

    // Start with first narration audio index in the updated queue
    const firstIndex = newQueue.findIndex(
      (q) => q.id === normalizedAudioList[0].id,
    );
    setCurrent(firstIndex);
    setPlaying(true);
  };

  if (!taraweehData) {
    return (
      <div className="narration-audio-list">
        <p>Loading taraweeh...</p>
      </div>
    );
  }

  return (
    <div className="narration-audio-list">
      <div className="narration-hero">
        <img
          className="narration-hero-image"
          src={`${baseUrl}storage/${taraweehData.image}`}
          alt={taraweehData.author}
        />

        <div className="narration-hero-info">
          <h1 className="narration-title">
            {taraweehData.title} {taraweehData.city} {taraweehData.year}
          </h1>
          <div className="narration-meta">
            <span className="reciter-name">{taraweehData.bio}</span>
          </div>

          <button className="play-all-btn" onClick={playtaraweeh}>
            ▶ Play All
          </button>
        </div>
      </div>

      <table className="list-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>Play / ❤️</th>
          </tr>
        </thead>
        <tbody>
          {taraweehAudioList.map((taraweeh, index) => (
            <tr key={taraweeh.id}>
              <td>{index + 1}</td>
              <td>{SURAH_NAMES[taraweeh.name]}</td>
              <td>
                <button onClick={() => playAudio(taraweeh)}>▶</button>

                <span className="liked">
                  <button onClick={() => toggleLike(taraweeh)}>
                    {liked.includes(taraweeh.id) ? "❤️" : "🤍"}
                  </button>
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Taraweeh;
